import { cn } from "@/common/utils/css.utils";
import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";
import NextImage from "next/image";

const BlogCard = ({ blog }) => {
  const { t } = useTranslation();

  const { title, description, slug, image, author } = blog.attributes;
  const imageAttributes =
    image?.data?.attributes ??
    author?.data?.attributes?.avatar?.data?.attributes ??
    {};
  const { url, width, height, alternativeText } = imageAttributes;

  return (
    <div className="flex flex-col rounded-[10px] bg-[#F9F9F9] p-[16px] md:p-[20px]">
      <Link href={`/blog/${slug}`}>
        <div className="relative mb-[20px] h-[250px] w-full cursor-pointer">
          <NextImage
            className={cn(
              "h-full w-full",
              width === height ? "object-contain" : "object-cover"
            )}
            width={width}
            height={height}
            src={url}
            alt={alternativeText}
          />
        </div>
      </Link>
      <div className="flex grow flex-col justify-between gap-y-[40px]">
        <div>
          <h4 className="mb-[16px] font-poppins text-[24px] font-semibold md:mb-[24px]">
            {title}
          </h4>
          <p>{description}</p>
        </div>
        <Link href={`/blog/${slug}`}>
          <a className="self-start font-poppins font-semibold text-[#0057FF] hover:underline">
            {t("blog:blog-read-more")}
          </a>
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
